import { render, staticRenderFns } from "./HeaderHome.vue?vue&type=template&id=54a336e2&"
import script from "./HeaderHome.vue?vue&type=script&lang=js&"
export * from "./HeaderHome.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports